import { useState } from 'react';
import { SuppliersApi } from '../../../api/ModuleApi';
import { getSupplierDto } from '../../../helpers/DtoGenerators';
import { FormType, NewFormProps } from '../../../interfaces/forms/FormTypes';
import { SupplierFormData } from '../../../interfaces/suppliers/SupplierTypes';
import { NewForm } from '../../shared/forms/NewForm';
import { SupplierForm } from './SupplierForm';

export const NewSupplierForm = ({ onClose }: NewFormProps) => {
    const [formData, setFormData] = useState<SupplierFormData>({})

    const handleClose = () => {
        setFormData({})
        onClose()
    }

    const handleNewSupplier = (formData: SupplierFormData) => {
        SuppliersApi.create(getSupplierDto(formData))
        .then(() => {
            handleClose()
        })
    }

    return (
        <NewForm
            title="Supplier"
            form={
                <SupplierForm
                    formData={formData}
                    formType={FormType.New}
                    title="Supplier"
                    onSubmit={ values => handleNewSupplier(values) }
                />
            }
            onClose={() => handleClose()}
        />
    )
}